














import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { GamePlayer } from '@/class/gamePlayer'

@Component
export default class SelfProclaimNoticeButton extends Vue {
  @Prop() game!: Game;
  @Prop() player!: GamePlayer;
  @Prop() isGallary!: boolean;

  get showsButton () {
    if (this.isGallary) {
      return false
    }

    if (this.player.isDead) {
      return false
    }

    return true
  }

  get canProclaim () {
    if (this.player.status.eatCrab) {
      return false
    }

    return true
  }
}
